// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconLightbulb, iconLightbulbTag } from '@ni/nimble-components/dist/esm/icons/lightbulb';
import { wrap } from '../../utilities/react-wrapper';

export type { IconLightbulb };
export { iconLightbulbTag };
export const NimbleIconLightbulb = wrap(IconLightbulb);